import type { MyBalanceView } from "../api/myBillingService";

/** 低余额提示阈值:积分池剩余 / 本期授予 < 5%。 */
export const LOW_BALANCE_RATIO = 0.05;

/**
 * 积分池是否快用完了(0926 修复波 F)。
 *
 * 口径与「我的套餐」桶卡一致:credit_pool 各代 remaining / totalUnits 求和再比。
 * total<=0(没配积分池)不提示 —— 那是「没开通」,不是「快用完」。
 * 客服/陪练的会话桶不是积分,不参与。
 */
export function creditPoolLowBalance(
  balances: readonly MyBalanceView[] | null | undefined
): { remaining: number } | null {
  let total = 0;
  let remaining = 0;
  for (const b of balances ?? []) {
    if (b.bucketKey !== "credit_pool") continue;
    total += b.totalUnits;
    remaining += b.remainingUnits;
  }
  if (total <= 0) return null;
  if (remaining / total >= LOW_BALANCE_RATIO) return null;
  return { remaining: Math.max(0, remaining) };
}
